import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EditorModule } from '@tinymce/tinymce-angular';

// Material Modules
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';

// Components
import { KontrolltermineComponent } from './kontrolltermine.component';
import { KontrollterminEditComponent } from './kontrolltermin-edit/kontrolltermin-edit.component';
import { KontrolltermineRoutingModule } from './kontrolltermine-routing.module';

// Status View Components
import { GeloeschtViewComponent } from './status-views/geloescht-view/geloescht-view.component';
import { FreigabeViewComponent } from './status-views/freigabe-view/freigabe-view.component';
import { GeplantViewComponent } from './status-views/geplant-view/geplant-view.component';
import { AbgebrochenViewComponent } from './status-views/abgebrochen-view/abgebrochen-view.component';
import { FehlerhaftViewComponent } from './status-views/fehlerhaft-view/fehlerhaft-view.component';

// Shared Components
import { ConfirmationDialogComponent } from '../shared/components/confirmation-dialog/confirmation-dialog.component';

// Dialog Components
import { DialogIndikatorEditComponent } from './dialogs/dialog-indikator-edit/dialog-indikator-edit.component';
import { EmailPreviewDialogComponent } from './dialogs/email-preview-dialog/email-preview-dialog.component';
import { ImageModalComponent } from './dialogs/image-modal/image-modal.component';
import { EingesetzteProdukteDialogComponent } from './dialogs/eingesetzte-produkte-dialog/eingesetzte-produkte-dialog.component';
import { ReportCategorySelectionDialogComponent } from './dialogs/report-category-selection-dialog/report-category-selection-dialog.component';
import { CreateKontrollterminDialogComponent } from './dialogs/create-kontrolltermin-dialog/create-kontrolltermin-dialog.component';
import { ChangeTechnikerDialogComponent } from './dialogs/change-techniker-dialog/change-techniker-dialog.component';
import { MultiSelectDialogComponent } from './dialogs/multi-select-dialog/multi-select-dialog.component';

// Shared Components
import { MultiSelectComponent } from '../shared/components/multi-select/multi-select.component';
import { HeaderInfoComponent } from './shared/header-info/header-info.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    KontrolltermineRoutingModule,
    EditorModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    MatTooltipModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatCardModule,
    MatRadioModule,
    MatCheckboxModule
  ],
  declarations: [
    KontrolltermineComponent,
    KontrollterminEditComponent,
    // Status View Components
    GeloeschtViewComponent,
    FreigabeViewComponent,
    GeplantViewComponent,
    AbgebrochenViewComponent,
    FehlerhaftViewComponent,
    // Shared Components
    ConfirmationDialogComponent,
    // Dialog Components
    DialogIndikatorEditComponent,
    EmailPreviewDialogComponent,
    ImageModalComponent,
    EingesetzteProdukteDialogComponent,
    ReportCategorySelectionDialogComponent,
    CreateKontrollterminDialogComponent,
    ChangeTechnikerDialogComponent,
    MultiSelectDialogComponent,
    // Shared Components
    MultiSelectComponent,
    HeaderInfoComponent,
  ],
  providers: [],
})
export class KontrolltermineModule { }
